export const iconFontAwesomeAutomotiveCarBurst = (
	<i className="fa-solid fa-car-burst"></i>
);
